import { LoadingSpinner } from "@/components/custom-ui/loading.spinner";
import { useUserStore } from "@/store/user";
import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";

export const PrivateRoute = ({ children }: { children: ReactNode }) => {
  const { isAuth, isLoading } = useUserStore((state) => ({
    isAuth: state.isAuth,
    isLoading: state.isLoading,
  }));

  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (isAuth === false || isAuth === undefined) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};
